(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["claudebanner"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const banner = document.getElementById('skinpop-banner');
  const closeBtn = banner.querySelector('.skinpop-banner__close');
  const storageKey = 'skinpop-banner-closed';
  
  if (localStorage.getItem(storageKey)) {
    banner.style.display = 'none';
  }
  
  closeBtn.addEventListener('click', function() {
    banner.setAttribute('data-closed', 'true');
    localStorage.setItem(storageKey, 'true');
    setTimeout(() => banner.style.display = 'none', 400);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
